import { c as createFocusTrap } from './focus-trap.esm-BUj_YYcQ.js';

/**
 * @class MegaMenu
 * @extends HTMLElement
 */
class MenuBlocks extends HTMLElement {
  click = this.hasAttribute('click') || false;
  mouse = this.hasAttribute('mouse') || false;
  eksterBar = this.closest('ekster-bar') || null;
  /**
   * @method connectedCallback
   * @description Lifecycle method called when the element is connected to the DOM.
   */
  connectedCallback() {
    // this.overlay = this.querySelector('[data-menu-blocks="overlay"]');
    this.triggers = this.querySelectorAll('[data-menu-blocks="trigger"]');
    this.blocks = this.querySelectorAll('menu-block');

    this.triggers.forEach((trigger) => {
      if (this.click) {
        trigger.addEventListener('click', (event) => this.openNextLevel(event));
      }
      if (this.mouse) {
        trigger.addEventListener('mouseenter', (event) => this.openNextLevel(event));
      }
    });

    if (this.mouse) {
      this.addEventListener('mouseleave', (event) => this.closeNextLevel(event));
    }
  }

  // disconnectedCallback() {
  // }

  /**
   * @method openNextLevel
   * @param {Object} event
   */
  openNextLevel(event) {
    const { currentTarget: trigger } = event;
    this.blocks.forEach((block) => {
      block.close();
    });
    const target = trigger.getAttribute('aria-controls');
    if (!target) return;
    trigger.setAttribute('aria-expanded', 'true');
    const targetElement = this.querySelector(`#${target}`);
    !targetElement.classList.contains('open') ? targetElement.open() : targetElement.close();
  }

  /**
   * @method closeNextLevel
   */
  closeNextLevel() {
    publish('menu-blocks:close');
    this.blocks.forEach((block) => {
      block.close();
    });
  }
}

customElements.define('menu-blocks', MenuBlocks);

class MenuBlock extends HTMLElement {
  connectedCallback() {
    this.MenuBlocks = this.closest('menu-blocks');
    this.triggers = this.closest('menu-blocks')?.querySelectorAll('[data-menu-blocks="trigger"]');
    this.trap = createFocusTrap(this, {
      allowOutsideClick: true,
      initialFocus: false,
    });
  }

  open() {
    this.setAttribute('aria-hidden', 'false');
    this.classList.add('open');
    this.trap.activate();
    this.dispatchEvent(new CustomEvent('menu-blocks:open', { bubbles: true }));
  }

  close() {
    this.setAttribute('aria-hidden', 'true');
    this.classList.remove('open');
    this.trap.deactivate();
    this.MenuBlocks.querySelector(`button[aria-controls="${this.id}"]`)?.setAttribute(
      'aria-expanded',
      'false'
    );
    this.triggers?.forEach((trigger) => {
      trigger?.setAttribute('aria-expanded', 'false');
    });
    this.dispatchEvent(new CustomEvent('menu-blocks:close', { bubbles: true }));
  }
}

customElements.define('menu-block', MenuBlock);
